export default [
  {
    path: "/termin-buchen",
    name: "PublicAppointmentBooking",
    component: () => import("@/views/appointments/PublicAppointmentBooking.vue"),
    meta: {
      publicAppointmentBooking: true,
      hideAppBar: true,
      hideBottomNavigation: true,
      disableChatToasts: true,
      fullWidth: true,
      backgroundColor: "#f4f7f4",
    },
  },
]
